module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1054-41056a1e84e3a2c14b853af643be53f0.png";